// Kit A+B in the cart: both components are added with the same hidden property `_kit` (see tc-product.js).
// Any quantity change or removal of one line (cart drawer, cart page...) goes through /cart/change;
// for a kit line it is turned into /cart/update with the same quantity for every line of that kit,
// keeping the theme's request (sections) so its own re-render keeps working.
(() => {
  if (window.tcKitCart) return;
  window.tcKitCart = true;
  const orig = window.fetch.bind(window);
  const isChange = (u) => /\/cart\/change(\.js)?(\?|$)/.test(u);

  window.fetch = async (input, init) => {
    const url = typeof input === "string" ? input : input && input.url;
    if (!url || !isChange(url) || !init || typeof init.body !== "string") return orig(input, init);
    let body;
    try {
      body = JSON.parse(init.body);
    } catch (e) {
      return orig(input, init);
    }
    let cart;
    try {
      cart = await (await orig("/cart.js", { headers: { Accept: "application/json" } })).json();
    } catch (e) {
      return orig(input, init);
    }
    // the theme sends either id (line key or variant id) or line (1-based index, sometimes the key)
    const ref = body.id != null ? body.id : body.line;
    const item =
      cart.items.find((i) => i.key === String(ref)) ||
      (body.line != null && /^\d+$/.test(String(body.line)) && Number(body.line) <= cart.items.length ? cart.items[Number(body.line) - 1] : null) ||
      (body.id != null ? cart.items.find((i) => i.variant_id === Number(body.id)) : null);
    const kit = item && item.properties && item.properties._kit;
    if (!kit) return orig(input, init);

    const quantity = Math.max(0, parseInt(body.quantity, 10) || 0);
    const updates = {};
    cart.items.forEach((i) => {
      if (i.properties && i.properties._kit === kit) updates[i.key] = quantity;
    });
    const next = { updates };
    if (body.sections) {
      next.sections = body.sections;
      next.sections_url = body.sections_url;
    }
    return orig(url.replace(/\/cart\/change/, "/cart/update"), { ...init, body: JSON.stringify(next) });
  };
})();
